import { useState, useEffect } from "react";
import HeaderSearch from "@/components/feature/HeaderSearch";

export default function MobileSearch() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="sm:hidden ml-auto w-11 h-11 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors shrink-0 cursor-pointer"
        aria-label="Ara"
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        <i className="ri-search-line text-xl" aria-hidden="true"></i>
      </button>

      <div className="hidden sm:flex flex-1 max-w-[360px]">
        <HeaderSearch />
      </div>

      {open && (
        <div
          className="fixed inset-0 z-[70] sm:hidden bg-background-50 flex flex-col"
          role="dialog"
          aria-modal="true"
          aria-label="Ara"
        >
          <div className="flex items-center gap-2 h-14 px-3 border-b border-background-200">
            <div className="flex-1">
              <HeaderSearch autoFocus />
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-11 h-11 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors shrink-0 cursor-pointer"
              aria-label="Aramayı kapat"
            >
              <i className="ri-close-line text-2xl" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      )}
    </>
  );
}